import Axios, { AxiosPromise, AxiosResponse } from 'axios';
import { getDapiApiKey, getGoogleCaptchaKey, getNewDapiPath } from '../../../config/ConfigService';
import config from '../../../login/config';
import { getTokenCaptchaV3 } from '../../../services/captcha/CaptchaService';
import { UserServiceResponse } from './UserServiceResponse';

const lookupLoginUserWithCaptcha = async (
  username: string,
): Promise<AxiosResponse<[UserServiceResponse]>> => {
  const captchaToken = await getTokenCaptchaV3(getGoogleCaptchaKey());
  return lookupLoginUser(username, captchaToken);
};

const lookupRegistrationUserWithCaptcha = async (
  username: string,
): Promise<AxiosResponse<[UserServiceResponse]>> => {
  const captchaToken = await getTokenCaptchaV3(getGoogleCaptchaKey());
  return lookupRegistrationUser(username, captchaToken);
};

const lookupRegistrationUser = (
  username: string,
  captchaToken: string,
): AxiosPromise<[UserServiceResponse]> => {
  const resourcePath = `${getNewDapiPath()}/v1/registration/users`;
  return lookupUser(resourcePath, username, captchaToken);
};

const lookupLoginUser = (
  username: string,
  captchaToken: string,
): AxiosPromise<[UserServiceResponse]> => {
  const resourcePath = `${getNewDapiPath()}/v1/users`;
  return lookupUser(resourcePath, username, captchaToken);
};

const lookupUser = (
  resourcePath: string,
  username: string,
  captchaToken: string,
): AxiosPromise<[UserServiceResponse]> => {
  const url = `${resourcePath}/${username}?token=${captchaToken}`;
  return Axios.get<[UserServiceResponse]>(url, {
    headers: {
      'cache-control': 'no-cache',
      'Content-Type': 'application/json',
      'x-api-key': getDapiApiKey(),
    },
    timeout: config.requestTimeoutMs,
  });
};

export { lookupLoginUserWithCaptcha, lookupRegistrationUserWithCaptcha };
